import React, { Component } from "react";
import _ from "lodash";
import { isBlockedShortCode } from "../../utils/shortCodeStatus";

class TableBody extends Component {
  renderCell = (item, column) => {
    if (column.content) return column.content(item);
    //  var options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' ,hour: 'numeric' ,minute: 'numeric', second: 'numeric'};
    //  if(item['MO_Date'] ||column.path==="MO_Date"  ) {
    //   //alert(_.get(item, column.path))

    //   return   item['MO_Date'].toLocaleDateString('en-US', options)
    //  }

    return _.get(item, column.path);
  };

  createKey = (item, column) => {
    return item.ReplyID + (column.path || column.key);
  };

  render() {
    const { data, columns } = this.props;

    return (
      <tbody>
        {data.map((item) => (
          <tr
            key={item.ReplyID ? item.ReplyID : item.id}
            className={`${item.MOShortCode
              ? item.MOShortCode === 4022
                ? " text-right row4022color"
                : item.MOShortCode === 2337
                ? "text-right text-primary"
                : item.MOShortCode === 6877
                ? "text-right row6877color"
                : item.MOShortCode === 6055
                ? "text-right row6055color"
                : item.MOShortCode === 3900
                ? "text-right row3900color"
                : item.MOShortCode === 2304
                ? "text-right row2304color"
                : ""
              : item.isuser && item.isreply
              ? " text-right row4022color"
              : item.isreply
              ? "text-right row6877color"
              : "text-right text-primary"}${item.MOShortCode &&
              isBlockedShortCode(item.MOShortCode)
              ? " row-blocked"
              : ""}`}
          >
            {columns.map((column) => (
              <td key={this.createKey(item, column)}>
                {this.renderCell(item, column)}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    );
  }
}

export default TableBody;



// WEBPACK FOOTER //
// ./src/components/common/tableBody.jsx